import { Component, OnInit, HostListener } from '@angular/core';

import * as $ from 'jquery';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
        $('.navbar-toggler').on('click', () => {
            $('#navbarSupportedContent').toggleClass('show');
            $('.navbar-toggler').toggleClass('expand');
        });
        $('.dropdown-menu .dropdown-item').on('click', () => {
            $('#navbarSupportedContent').removeClass('show');
            $('.navbar-toggler').removeClass('expand');
        });
    }
    @HostListener('window:scroll', ['$event'])
    onScroll(event) {
        if (window.pageYOffset >= $('#landing').outerHeight()) {
            $('.navbar.navbar-custom').addClass('show');
        } else {
            $('.navbar.navbar-custom').removeClass('show');
        }
    }

}
